<template>
  <div id="projectlogs">
    <div class="logsBox">
      <ul class="logList">
        <li v-for="item in tableData">
          <div class="leftDate">{{item.add_time}}</div>
          <div class="rightDetails">
            <p style="margin-top:0px;margin-bottom:5px">
              <span>操作人员:</span>
              <span style="color:#333;margin-left:10px" v-if="item.member">{{item.member.nickname}}</span>
            </p>
            <p class="content">
              <span class="title">提交数据:</span>
              <span class="right">{{item.log}}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="pageRow">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 30]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="Total"
        ></el-pagination>
      </div>
    </div>
    <!-- 附件详情弹窗 -->
    <el-dialog
      :visible.sync="imgDia"
      width="50%"
      :before-close="imghandleClose"
      class="addClientDia"
      node-key="id"
      @close="imghandleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">{{'河南邦泰合力管理咨询有限公司'}}</span>
      </div>
      <div class="diaContainer">
        <el-tree :data="data" :props="props" show-checkbox @check-change="handleCheckChange"></el-tree>
      </div>
      <div slot="footer" class="dialog-footer imgFooter">
        <el-button style="background-color:#ccc" type="primary" @click="imgDia=false">取 消</el-button>
        <el-button type="primary">生成目录</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgDia: false,
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      showForm: '',

      props: {
        label: 'label',
        children: 'children',
      },
      member_id: '',
      tableData: [],
      data: [
        {
          id: 1,
          label: '邦泰1',
          children: [
            {
              id: 4,
              label: '邦泰2',
            },
          ],
        },
      ],
      token: '',
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      checkOutImgIndex: '',
    }
  },
  methods: {
    // Project/history
    // *获取日志
    async getLogList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('project_id', this.details_project_id)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/history',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('项目登记详情', this.tableData)
    },
    handleCheckChange(val1, val2, val3) {
      console.log('val1', val1)
      console.log('val2', val2)
      console.log('val3', val3)
    },
    handleMulu() {
      this.imgDia = true
    },
    // table选中状态
    handleSelectionChange(row, rowIndex, $event) {
      // console.log('row', row)
      console.log('rowIndex', rowIndex)
      // console.log('select123123ionri', $event)
    },
    handleClosed() {},
    imghandleClose(done) {
      this.imgDia = false
    },
    imghandleClosed() {},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.currentPage = 1
      this.getLogList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getLogList()
      console.log(`当前页: ${val}`)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getLogList()
    }
  },
}
</script>
<style lang="less" scoped>
#projectlogs {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 30px;
  .logsBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
    .logList {
      height: calc(100% - 40px);
      overflow-y: auto;
      li {
        height: 220px;
        display: flex;
        margin-bottom: 30px;
        .leftDate {
          width: 20%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #eff8ff;
          color: #333;
          font-size: 18px;
        }
        .rightDetails {
          box-sizing: border-box;
          padding: 30px;
          padding-right: 50px;
          width: 80%;
          background-color: #f4f5f6;
          color: #128bf1;
          font-size: 18px;
          .content {
            width: 100%;
            display: flex;
            flex-wrap: nowrap;
            .title {
              display: block;
              width: 100px;
            }
            .right {
              // height: 150px;
              width: calc(100% - 100px);
              display: -webkit-box;
              -webkit-box-orient: vertical;
              font-size: 16px;
              color: #666;
              -webkit-line-clamp: 6;
              overflow: hidden;
            }
          }
        }
      }
    }
    // 分页行
    .pageRow {
      height: 20px;
      box-sizing: border-box;
      margin-top: 20px;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
  }
}

// 修改弹窗样式
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 3vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }

    .dialog-footer {
      width: 100%;
      display: flex;
      padding-left: 30%;
      margin-top: 30px;
      .el-button {
        // width: 180px;
        width: 23%;
        height: 50px;
        padding: 0;
        font-size: 20px;
        font-weight: normal;
        color: #fff;
        border: none;
        border-radius: 25px;
        background-color: #40a0f2;
        margin-bottom: 10px;
      }
      .el-button:first-child {
        margin-right: 5%;
      }
    }
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
// 修改表格样式
#projectlogs {
  /deep/.zk-table {
    font-size: 16px;
  }
  /deep/.zk-table__body-row {
    height: 60px;
  }
  /deep/.zk-table__body-row:not(:first-of-type) {
    border-top: none;
  }
  /deep/.zk-table__header-row {
    background-color: #40a0f2;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    .zk-table__header-cell {
      font-weight: normal;
    }
  }
  /deep/.zk-table--firstProp-header-inner {
    padding-left: 15px;
  }
}
// 修改表格收缩图标
/deep/.zk-icon {
  display: inline-block;
  vertical-align: middle;
  width: 19px;
  height: 16px;
  background: url(../../../assets/image/icon_wenj@2x.png) no-repeat;
  background-size: 100% 100%;
}
/deep/.zk-icon::before {
  display: none;
}
.diaContainer {
  padding-left: 100px;
  /deep/.el-tree-node__content {
    height: 40px;
    .el-tree-node__label {
      font-size: 16px;
    }
  }
}
</style>
